import { useMessageBox } from '@/composables/useMessageBox'
import { useToast } from '@/composables/useToast'
import { useLoading } from '@/composables/useLoading'

const toast = useToast()
const messageBox = useMessageBox()
const loading = useLoading()

// 实现feedback工具类
export const Loading = {
  loading: (options?: any) => {
    loading.show(options)
  },
  hasLoading: () => {
    return loading.hasLoading()
  },
  close: () => {
    loading.close()
  }
}

export const Message = toast

//拟态弹出框
export const Modal = messageBox

export default { Loading, Message, Modal }
